import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import HeroSection from './components/HeroSection';
import VisualDemoCard from './components/VisualDemoCard';
import AzureServiceGrid from './components/FeatureGrid';
import PricingCards from './components/PricingCards';
import ComprehensiveFAQ from './components/ComprehensiveFAQ';
import CtaSection from './components/LifetimeCTA';
import Industries from './components/Industries';
import Navigation from './components/Navigation';
import ProductShowcase from './components/ProductShowcase';
import PublicLandingChatbot from '../../adapters/publicSite/PublicLandingChatbot';

import Footer from '../Landing/footer';
import { ThemeProvider } from '../Landing/theme-provider';
// import HowItWorks from './components/HowItWorks';

const Page = styled.div`
  width: 100%;
  min-height: 100vh;
  color: #0b0f1a;
  background: linear-gradient(135deg, #ffffff, rgba(221, 214, 254, 0.02));
`;

const Frame = styled.div`
  margin: 0 auto;
  padding: 24px;

  @media (max-width: 768px) {
    padding: 16px;
  }

  @media (max-width: 480px) {
    padding: 12px;
  }
`;

const Hero = styled.section`
  position: relative;
  padding: 20px 0 60px;

  @media (max-width: 900px) {
    padding: 60px 0 40px;
  }

  @media (max-width: 480px) {
    padding: 40px 0 24px;
  }
`;

const HomeStory: React.FC = () => {
    // Handle hash navigation when arriving from other pages
    useEffect(() => {
        if (window.location.hash) {
            const id = window.location.hash.replace('#', '');
            // Wait a bit for the page to render
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) {
                    const offset = 100;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }, 100);
        }
    }, []);

    return (
        <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
            <Page>
                <Navigation />
                <Frame>
                    <Hero>
                        <HeroSection>
                            <VisualDemoCard />
                        </HeroSection>
                    </Hero>
                    {/* <HowItWorks /> */}
                    <AzureServiceGrid />
                    <ProductShowcase />
                    <Industries />
                    <PricingCards />
                    <CtaSection />
                    <ComprehensiveFAQ />

                    <Footer />
                </Frame>
                <PublicLandingChatbot />
            </Page>
        </ThemeProvider>
    );
};

export default HomeStory;
